import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

// Overlay reutilizable de "guardando… / listo": grisa la pantalla mientras
// `submitting` es true (spinner) y, cuando `mostrar` pasa a true, dibuja un
// tilde verde, reproduce `sonido` (si se pasa) y se desvanece solo antes de
// avisar por `onFinalizado` — ahí el llamador resetea su estado o navega.
// No usar `sonido` en pantallas donde el éxito no debe sonar (ej. anular).

const DURACION_VISIBLE_MS = 900;
const DURACION_SALIDA_MS = 300;
const DEMORA_SONIDO_MS = 750; // cuando el tilde termina de dibujarse (circulo .5s + check .35s con .4s de delay)

function TildeExito({ submitting = false, mostrar = false, onFinalizado, sonido, mensaje }) {
  const [saliendo, setSaliendo] = useState(false);
  const onFinalizadoRef = useRef(onFinalizado);
  const sonidoRef = useRef(sonido);
  onFinalizadoRef.current = onFinalizado;
  sonidoRef.current = sonido;

  useEffect(() => {
    if (!mostrar) { setSaliendo(false); return undefined; }
    const timers = [];
    if (sonidoRef.current) timers.push(setTimeout(() => sonidoRef.current(), DEMORA_SONIDO_MS));
    timers.push(setTimeout(() => {
      setSaliendo(true);
      timers.push(setTimeout(() => {
        setSaliendo(false);
        onFinalizadoRef.current?.();
      }, DURACION_SALIDA_MS));
    }, DURACION_VISIBLE_MS));
    return () => timers.forEach(clearTimeout);
  }, [mostrar]);

  if (!submitting && !mostrar) return null;

  return (
    <Box sx={{
      position: 'fixed', inset: 0, zIndex: 2000,
      bgcolor: 'rgba(20,20,20,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      opacity: saliendo ? 0 : 1,
      transition: 'opacity .28s ease',
    }}>
      <style>{`
        @keyframes tildeCirculo { to { stroke-dashoffset: 0; } }
        @keyframes tildeCheck { to { stroke-dashoffset: 0; } }
      `}</style>
      {mostrar ? (
        <Box sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5,
          transform: saliendo ? 'scale(0.85)' : 'scale(1)',
          opacity: saliendo ? 0 : 1,
          transition: 'transform .28s ease, opacity .28s ease',
        }}>
          <svg viewBox="0 0 100 100" width="180" height="180">
            <circle
              cx="50" cy="50" r="45" fill="none" stroke="#4caf50" strokeWidth="6"
              strokeDasharray="283" strokeDashoffset="283"
              style={{ animation: 'tildeCirculo .5s ease-out forwards', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.35))' }}
            />
            <path
              d="M28 52 L44 68 L74 34" fill="none" stroke="#4caf50" strokeWidth="7"
              strokeLinecap="round" strokeLinejoin="round"
              strokeDasharray="70" strokeDashoffset="70"
              style={{ animation: 'tildeCheck .35s ease-out .4s forwards' }}
            />
          </svg>
          {mensaje && <Typography sx={{ color: '#fff', fontWeight: 600 }}>{mensaje}</Typography>}
        </Box>
      ) : (
        <CircularProgress size={64} sx={{ color: '#fff' }} />
      )}
    </Box>
  );
}

export default TildeExito;
